import getContentIdOrDefaultUtil from "./getContentIdOrDefault"


export {default as replacePlaceholders} from "./replacePlaceholders"

export const formatQuestionText = getContentIdOrDefaultUtil.formatQuestionText
export const formatDriverName = getContentIdOrDefaultUtil.formatDriverName
export const formatDriverDescription = getContentIdOrDefaultUtil.formatDriverDescription
export const formatAnswerText = getContentIdOrDefaultUtil.formatAnswerText
